import { WILDFIRE_BURN_YEARS } from '@/components/Map/MapLayers/wildfireBurnsConfig';
import { GBIF_TAXON_MORCHELLA_GENUS } from '@/utils/map/gbifSpeciesTaxon';
import {
  BURN_MOREL_FORECAST_NAME,
  NATURAL_MOREL_SPECIES_NAME,
  NATURAL_MOREL_SPECIES_SLUG,
} from '@/constants/burnMorelForecast';

/** Map toolbar dropdown, pills, and wildfire burn layer quick search (single source of truth). */
export const MAP_WILDFIRE_QUICK_SEARCH_LABEL = BURN_MOREL_FORECAST_NAME;

const wildfireYearRangeLabel = `wildfires (${WILDFIRE_BURN_YEARS[0]}–${WILDFIRE_BURN_YEARS[WILDFIRE_BURN_YEARS.length - 1]})`;

/** Opens the Burn Morels species pane (layer + species info). */
export const MAP_BURN_MOREL_SPECIES_QUERIES = new Set<string>([
  MAP_WILDFIRE_QUICK_SEARCH_LABEL.toLowerCase(),
  'burn morel',
]);

/** Turns the wildfire-burns layer on without opening a species pane. */
export const MAP_WILDFIRE_LAYER_QUERIES = new Set<string>([
  wildfireYearRangeLabel,
  '2026 wildfires',
  'wildfires',
  'wildfire',
  'burn maps',
  'burn map',
]);

/** Lowercase queries for the burn layer or the Burn Morels species. */
export const MAP_WILDFIRE_QUICK_SEARCH_QUERIES = new Set<string>([
  ...MAP_BURN_MOREL_SPECIES_QUERIES,
  ...MAP_WILDFIRE_LAYER_QUERIES,
]);

/** Toolbar dropdown filter — match label and legacy wildfire/burn aliases. */
export function mapWildfireQuickSearchMatchesFilter(query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return false;
  if (MAP_WILDFIRE_QUICK_SEARCH_LABEL.toLowerCase().includes(q)) return true;
  for (const term of MAP_WILDFIRE_QUICK_SEARCH_QUERIES) {
    if (term.includes(q)) return true;
  }
  return false;
}

/**
 * Toolbar pills use short queries (`ramps`, `morels`) that may not match `Species.name` exactly,
 * and species data may still be loading (`speciesList` empty). Slugs/taxonIds for quick picks.
 */
export const MAP_QUICK_SPECIES_LOOKUP: Record<
  string,
  { slug: string; taxonId: number; displayName: string }
> = {
  ramps: {
    slug: "allium-tricoccum",
    taxonId: 2856301,
    displayName: "Ramps",
  },
  morels: {
    slug: NATURAL_MOREL_SPECIES_SLUG,
    taxonId: GBIF_TAXON_MORCHELLA_GENUS,
    displayName: NATURAL_MOREL_SPECIES_NAME,
  },
};
